import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import NFTs from "../_metadata.json";
import abi from "../abi2.json";
import Web3 from "web3";
import { ethers } from "ethers";
import { TransferNFTCall } from "../utils/interact";

import hensjs from "hensjs";
const { ethereum } = window;
const web3 = new Web3(ethereum);
const address = "0xE86ae8f38372d26F8ffAC37deba733a77f101Ac7";
const chainID = 1;

function Transfer() {
  const tokenId = useParams().id;
  const [owner, setAddress] = useState({ success: false });
  const [NFT, setNFT] = useState([]);
  const [addressNFT, setAddressNFT] = useState("");
  const [status, setStatus] = useState("");
  const [provider, setProvider] = useState(null);
  const [signer, setSigner] = useState(null);

  let tempContract;
  useEffect(async () => {
    let tempProvider = new ethers.providers.Web3Provider(window.ethereum);
    setProvider(tempProvider);

    let tempSigner = tempProvider.getSigner();
    setSigner(tempSigner);

    tempContract = new ethers.Contract(address, abi, tempSigner);

    let obj = NFTs.find((o) => o.edition === parseInt(tokenId));
    setNFT(obj);
    console.log(1);

    const onwers = await tempContract.ownerOf(tokenId);
    if (onwers) {
      const domain = await hensjs.getNameOfOwner(onwers);
      if (domain === "") {
        setAddress({
          success: true,
          address: onwers,
        });
      } else {
        setAddress({
          success: true,
          address: domain,
        });
      }
    }
  }, []);

  const TransferNFT = async () => {
    const response = await TransferNFTCall(addressNFT, tokenId);
    setStatus(response.status);
  };

  return (
    <section
      id="about"
      className="container about_container"
      style={{
        margin: "9rem auto",
      }}
    >
      <img
        src={`https://monkeydoonft.online/images/${tokenId}.png`}
        className="big_img"
        style={{
          width: "100%",
          borderRadius: "40px",
          padding: "20px",
        }}
      />
      <div
        className=" about_text"
        style={{
          paddingRight: "19px",
        }}
      >
        <div className="about_text_header">
          <h5>Transfer NFT</h5>
          <h2>MonkeyDoo #{tokenId}</h2>
        </div>
        <div
          className="about_text_main"
          style={{
            overflow: "scroll",
          }}
        >
          {owner.success === true ? (
            <h5
              style={{
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Current Onwer : {owner.address}
            </h5>
          ) : (
            <>No Owner Yet</>
          )}
          <div>
            <input
              onChange={(e) => setAddressNFT(e.target.value)}
              className="input"
              placeholder="Enter Address to send NFT"
            />
            <br />
            {status && <>{status}</>}
            <button
              class="btn btn-primary"
              style={{
                width: "100%",
                marginTop: "1rem",
              }}
              onClick={() => TransferNFT()}
            >
              Transfer NFT
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Transfer;
